// extracted by mini-css-extract-plugin
export var boxItems = "_cc-1";
export var boxItemsLg = "_cc-2";
export var button = "_cc-7";
export var buttonLg = "_cc-8";
export var filterGroupBox = "_cc-0";
export var icon = "_cc-3";
export var iconSecondary = "_cc-6";
export var iconWrapper = "_cc-4";
export var iconWrapperLg = "_cc-5";